document.querySelectorAll('[data-eiadid]').forEach(el => {
  el.value = '';
})
